import styled from 'styled-components';

export const SectionStyled = styled.section`
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 8rem;
`;
